<template>
  <div class="c-balloonTooltip">
    <balloon-dropdown
      :is-active="isActive"
      :position="position"
      :width="width"
      :disabled="disabled"
      @active-change="$emit('active-change', $event)"
    >
      <slot
        name="trigger"
        slot="trigger"
      />
      <aside class="c-balloonTooltip_content">
        <div
          class="c-balloonTooltip_title"
          slot="title"
          v-if="this.$slots.title"
        >
          <slot name="title">
            ここにタイトル
          </slot>
        </div>
        <div class="c-balloonTooltip_body">
          <slot name="body">
            ここにタイトル
          </slot>
        </div>
        <div
          class="c-balloonTooltip_footer"
          v-if="this.$slots.footer"
        >
          <slot name="footer">
            ここはフッター
          </slot>
        </div>
      </aside>
    </balloon-dropdown>
  </div>
</template>
<script>
import BalloonDropdown, { POSITIONS as _POSITIONS } from '~/components/molecules/BalloonDropdown'

export const POSITIONS = _POSITIONS

export default {
  name: 'BalloonTooltip',
  components: {
    BalloonDropdown
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'is-bottom-center',
      validator(v) {
        return POSITIONS.includes(v)
      }
    },
    width: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {}
}
</script>
<style lang="scss" scoped>
.c-balloonTooltip {
  cursor: default;

  &_content {
    padding: 0 1em;
    color: $color-font-base;
  }
  &_title {
    margin-bottom: 1em;
    font-size: 12px;
    font-weight: bold;
  }
  &_body {
    font-size: 12px;
    font-weight: normal;
  }
  &_footer {
    margin-top: 1em;
    font-size: 12px;
    font-weight: bold;
    text-align: right;
  }
}
</style>
